import * as Actions from './actions'
import {initialState} from '../store/initialState'

export const ShopsReducer = (state = initialState.shops, action) =>{
    switch(action.type){
        case Actions.DELETE_SHOPS:
            return{
                ...state,
                list:[...action.payload]//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        case Actions.FETCH_SHOPS:
            return{
                ...state,
                list:[...action.payload]//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        case Actions.INIT_SHOPS:
            return {
                ...initialState.products
            };
        default:
            return state
    }
}